import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { PRODUCT_IMAGE } from "./data/product";
const PAGE_TITLE = "Halloween PE Ready™ — Your Halloween PE Week Is Already Planned";
const PAGE_DESCRIPTION = "25 ready-to-run Halloween PE games, 10 visual stations, 8 complete lesson plans and printable resources for elementary and middle school PE teachers. 100% digital, instant access — $19.";
function setMeta(attr: "name" | "property", key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// SEO basics
document.documentElement.lang = "en";
document.title = PAGE_TITLE;
setMeta("name", "description", PAGE_DESCRIPTION);
setMeta("name", "viewport", "width=device-width, initial-scale=1");
setMeta("name", "robots", "index, follow");
setMeta("name", "theme-color", "#0E1220");
setMeta("property", "og:type", "product");
setMeta("property", "og:title", PAGE_TITLE);
setMeta("property", "og:description", PAGE_DESCRIPTION);
setMeta("property", "og:image", PRODUCT_IMAGE);
setMeta("name", "twitter:card", "summary_large_image");

// Warm up the image CDN connection before the hero image is requested
const preconnect = document.createElement("link");
preconnect.rel = "preconnect";
preconnect.href = "https://wsrv.nl";
preconnect.crossOrigin = "";
document.head.appendChild(preconnect);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-222" data-mp="1jkk07p4wlxwv" />);
}